module.exports = __webpack_public_path__ + "img/store_points.1e7b3d4f.png";